import React, { useState } from 'react';
import { AlertTriangleIcon, TruckIcon, DropletIcon, GaugeIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export const MissionAnalysis = () => {
  const [openSections, setOpenSections] = useState({
    supplyRequirements: true,
    carryingCapacity: false,
    maintenanceStatus: false
  });
  const toggleSection = (section: string) => {
    setOpenSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };
  return <div className="border border-gray-200 rounded-lg shadow-sm overflow-hidden bg-white mb-6" data-id="element-1285">
      <div className="p-5 border-b border-gray-200 bg-gray-50" data-id="element-1286">
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-1287">
          Mission Analysis
        </h3>
      </div>
      <div className="p-5" data-id="element-1288">
        {/* Section 1: Mission Supply Requirements */}
        <div className="border border-gray-200 rounded-md overflow-hidden mb-4" data-id="element-1289">
          <button onClick={() => toggleSection('supplyRequirements')} className="w-full px-4 py-3 flex items-center justify-between bg-gray-50 hover:bg-gray-100 transition-colors" data-id="element-1290">
            <div className="flex items-center" data-id="element-1291">
              <TruckIcon className="h-5 w-5 text-blue-600 mr-3" data-id="element-1292" />
              <h4 className="text-md font-semibold text-gray-800" data-id="element-1293">
                1. Mission Supply Requirements
              </h4>
            </div>
            {openSections.supplyRequirements ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-1294" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-1295" />}
          </button>
          {openSections.supplyRequirements && <div className="p-4" data-id="element-1296">
              <div className="overflow-x-auto" data-id="element-1297">
                <table className="min-w-full divide-y divide-gray-200 border" data-id="element-1298">
                  <thead className="bg-gray-50" data-id="element-1299">
                    <tr data-id="element-1300">
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1301">
                        Class
                      </th>
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1302">
                        Description
                      </th>
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1303">
                        Daily Requirement (Est.)
                      </th>
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1304">
                        Total Needed (7 Days)
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200" data-id="element-1305">
                    <tr data-id="element-1306">
                      <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1307">
                        I
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700" data-id="element-1308">
                        Rations & water
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1309">
                        1 MRE + 3 gal water/person/day × 120 pax = 120 MREs +
                        360 gal/day
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700" data-id="element-1310">
                        840 MREs + 2,520 gal water
                      </td>
                    </tr>
                    <tr data-id="element-1311">
                      <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1312">
                        III
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700" data-id="element-1313">
                        POL (Fuel – diesel)
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1314">
                        Avg 4 MPG, 500 total gallons/day (30 vehicles)
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700" data-id="element-1315">
                        3,500 gallons
                      </td>
                    </tr>
                    <tr data-id="element-1316">
                      <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1317">
                        V
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700" data-id="element-1318">
                        Ammunition
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1319">
                        2,000 rds 5.56mm + 400 rds 7.62mm/day + basic load
                        grenades
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700" data-id="element-1320">
                        Resupply required at 50% load
                      </td>
                    </tr>
                    <tr data-id="element-1321">
                      <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1322">
                        IX
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700" data-id="element-1323">
                        Repair parts
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1324">
                        Tires, belts, fuel filters, brake fluid, batteries
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700" data-id="element-1325">
                        15–20 parts/week
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>}
        </div>
        {/* Section 2: Carrying Capacity Onboard */}
        <div className="border border-gray-200 rounded-md overflow-hidden mb-4" data-id="element-1326">
          <button onClick={() => toggleSection('carryingCapacity')} className="w-full px-4 py-3 flex items-center justify-between bg-gray-50 hover:bg-gray-100 transition-colors" data-id="element-1327">
            <div className="flex items-center" data-id="element-1328">
              <GaugeIcon className="h-5 w-5 text-green-600 mr-3" data-id="element-1329" />
              <h4 className="text-md font-semibold text-gray-800" data-id="element-1330">
                2. Carrying Capacity Onboard
              </h4>
            </div>
            {openSections.carryingCapacity ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-1331" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-1332" />}
          </button>
          {openSections.carryingCapacity && <div className="p-4" data-id="element-1333">
              <div className="overflow-x-auto" data-id="element-1334">
                <table className="min-w-full divide-y divide-gray-200 border" data-id="element-1335">
                  <thead className="bg-gray-50" data-id="element-1336">
                    <tr data-id="element-1337">
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1338">
                        Vehicle Type
                      </th>
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1339">
                        Quantity
                      </th>
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1340">
                        Est. Supply Capacity
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200" data-id="element-1341">
                    <tr data-id="element-1342">
                      <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1343">
                        LMTVs (cargo/troop)
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700" data-id="element-1344">
                        6
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1345">
                        2 days Class I per truck = 12 days total
                      </td>
                    </tr>
                    <tr data-id="element-1346">
                      <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1347">
                        Fuel HEMTTs
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700" data-id="element-1348">
                        1
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1349">
                        2,500 gallons diesel (half of total need)
                      </td>
                    </tr>
                    <tr data-id="element-1350">
                      <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1351">
                        M871 Ammo Trailer
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700" data-id="element-1352">
                        1
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1353">
                        4 pallets = 100% basic load x2 days
                      </td>
                    </tr>
                    <tr data-id="element-1354">
                      <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1355">
                        Water Buffalo (400 gal)
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700" data-id="element-1356">
                        2
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1357">
                        800 gal = ~2.2 days water for 120 pax
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-md" data-id="element-1358">
                <p className="text-sm text-blue-800 font-medium mb-0" data-id="element-1359">
                  Conclusion: Convoy carries ≈ 2.5–3 days of fuel, water, and
                  ammo. Rations max at ~3.5 days if LMTVs are dedicated.
                  Resupply is mandatory by Day 4.
                </p>
              </div>
            </div>}
        </div>
        {/* Section 3: Maintenance Status & Readiness */}
        <div className="border border-gray-200 rounded-md overflow-hidden" data-id="element-1360">
          <button onClick={() => toggleSection('maintenanceStatus')} className="w-full px-4 py-3 flex items-center justify-between bg-gray-50 hover:bg-gray-100 transition-colors" data-id="element-1361">
            <div className="flex items-center" data-id="element-1362">
              <DropletIcon className="h-5 w-5 text-amber-600 mr-3" data-id="element-1363" />
              <h4 className="text-md font-semibold text-gray-800" data-id="element-1364">
                3. Maintenance Status & Readiness
              </h4>
            </div>
            {openSections.maintenanceStatus ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-1365" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-1366" />}
          </button>
          {openSections.maintenanceStatus && <div className="p-4" data-id="element-1367">
              <div className="overflow-x-auto" data-id="element-1368">
                <table className="min-w-full divide-y divide-gray-200 border" data-id="element-1369">
                  <thead className="bg-gray-50" data-id="element-1370">
                    <tr data-id="element-1371">
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1372">
                        System
                      </th>
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1373">
                        Status
                      </th>
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1374">
                        Notes
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200" data-id="element-1375">
                    <tr data-id="element-1376">
                      <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1377">
                        HEMTT Fueler
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-green-700 font-medium" data-id="element-1378">
                        FMC
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1379">
                        No current faults
                      </td>
                    </tr>
                    <tr data-id="element-1380">
                      <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1381">
                        3x LMTVs
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-green-700 font-medium" data-id="element-1382">
                        FMC
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1383">
                        Tires near wear limit, 1 with minor oil seep
                      </td>
                    </tr>
                    <tr data-id="element-1384">
                      <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1385">
                        2x MRAPs
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-red-700 font-medium" data-id="element-1386">
                        NMC
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1387">
                        Awaiting radiator hose + brake system flush
                      </td>
                    </tr>
                    <tr data-id="element-1388">
                      <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1389">
                        Generator trailers
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-green-700 font-medium" data-id="element-1390">
                        FMC
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1391">
                        All operational
                      </td>
                    </tr>
                    <tr data-id="element-1392">
                      <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1393">
                        On-hand Class IX
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-amber-700 font-medium" data-id="element-1394">
                        30% stocked
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1395">
                        Lacks spare tires and common belts for field repair
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="mt-4 p-4 bg-amber-50 border border-amber-200 rounded-md" data-id="element-1396">
                <p className="text-sm text-amber-800 font-medium mb-0" data-id="element-1397">
                  Estimated maintenance push needed on D+4 at latest — forward
                  repair team or tow asset must be staged.
                </p>
              </div>
            </div>}
        </div>
      </div>
      <div className="p-5 border-t border-gray-200 bg-red-50" data-id="element-1398">
        <div className="flex items-start" data-id="element-1399">
          <AlertTriangleIcon className="h-5 w-5 text-red-600 mt-0.5 flex-shrink-0" data-id="element-1400" />
          <div className="ml-3" data-id="element-1401">
            <h3 className="text-lg font-semibold text-red-800" data-id="element-1402">
              Resupply Required
            </h3>
            <div className="mt-2 text-sm text-red-700" data-id="element-1403">
              <ul className="mt-1 list-disc pl-5 space-y-1" data-id="element-1404">
                <li data-id="element-1405">Internal supplies = ~3-day limit</li>
                <li data-id="element-1406">
                  Water capacity, fuel draw, and ammo usage exceed onboard
                  capacity before D+4
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>;
};